import moment from "moment/moment";
import { FixNumberData } from "../orders";

export function convertTo(journalLines, exportSettings) {
  const lines = journalLines.map(line => makeLine(line, exportSettings));
  return [makeHeaderLine(), ...lines].join("\n");
}

export function makeLine(journalLine, exportSettings) {
  let line = [];

  // ID
  line.push("Assist");

  // Owner ID
  line.push("");

  // Voucher Date IMP
  line.push( moment(journalLine.confirmedDate).format("YYYYMMDD"));

  // Due Date Imp
  line.push("");

  // Voucher NO
  line.push(journalLine.exportNumber);

  // Cash Reg No
  line.push(Limit(journalLine.confirmedBy?.name || "", 25));

  // Department
  line.push("");

  // Employee
  line.push("");

  // Cash Reg Code
  line.push("");

  // Subledger
  line.push("");

  // Invoice No
  line.push("");

  // XIdentifier
  line.push("");

  // Account
  line.push(journalLine.account);

  // Posting 1
  line.push("");

  // Posting 2
  line.push("");

  // X Posting
  line.push("");

  // Tax Rule
  line.push(isExportProductGroup(journalLine, exportSettings) ? "" : journalLine.item.productGroup.vatCode.code);

  // Text
  line.push(journalLine.comment || "");

  // Quantity
  line.push(FixNumberData(journalLine.item.quantity));

  // Amount
  line.push(FixNumberData(journalLine.grossPrice.value)); // TODO calc total without tax

  // Dummy 1
  line.push( moment(journalLine.confirmedDate).format("DD.MM.YYYY"));

  // Dummy 2
  line.push("");

  // End of Line
  line.push("x");

  return line.join(";");
}


export function isExportProductGroup(journalLine, exportSettings) {
  const account = journalLine.account;
  return account === exportSettings.cardAccount || account === exportSettings.cashAccount || account === exportSettings.mobilePaymentAccount;
}

export function makeHeaderLine() {

  
  let line = [];

  // ID
  line.push("ID");

  // Owner ID
  line.push("Owner Id");

  // Voucher Date IMP
  line.push("Voucher Date");

  // Due Date Imp
  line.push("Due Date Imp");

  // Voucher NO
  line.push("Voucher NO");

  // Cash Reg No
  line.push("Cash Reg No");

  // Department
  line.push("Department");

  // Employee
  line.push("Employee");

  // Cash Reg Code
  line.push("Cash Reg. Code");

  // Subledger
  line.push("Subledger");

  // Invoice No
  line.push("Invoice No");

  // XIdentifier
  line.push("XIdentifier");

  // Account
  line.push("Account");

  // Posting 1
  line.push("Posting 1");

  // Posting 2
  line.push("Posting 2");

  // X Posting
  line.push("X Posting");

  // Tax Rule
  line.push("TaxRule");

  // Text
  line.push("Text");

  // Quantity
  line.push("Quantity");

  // Amount
  line.push("Amount"); 

  // Dummy 1
  line.push("Dummy 1");

  // Dummy 2
  line.push("Dummy 2");

  // End of Line
  line.push("End of Line");

  return line.join(";");

}

function Limit(text, limit = 25) {
  if (!text) return "";
  if (text.length <= limit) return text;
  return text.substring(0, limit - 1);
}